import React from 'react';
import { getHobbyMediaStyle, HobbyMediaIcon, normalizeHobbyMediaId } from '../../content/hobbyMedia';

/**
 * Renders the default media fallback experience.
 *
 * @param {object} props - Component properties.
 * @param {*} props.className - class name value.
 * @param {*} props.fallbackType - fallback type value.
 * @param {*} props.variant - variant value.
 * @returns {JSX.Element} The rendered interface.
 */
export default function DefaultMediaFallback({
  className = '',
  fallbackType = 'hobby',
  variant = '',
}) {
  const mediaId = normalizeHobbyMediaId(fallbackType);
  const style = getHobbyMediaStyle(mediaId);
  return (
    <span
      className={`${className} default-media-fallback fallback-${mediaId} ${variant ? `entry-media entry-media--${variant}` : ''}`.trim()}
      style={{
        '--default-media-accent': style.accent,
        '--default-media-dark-bg': style.darkBackground,
        '--default-media-light-bg': style.lightBackground,
      }}
      aria-hidden="true"
    >
      <HobbyMediaIcon type={mediaId} />
    </span>
  );
}
